import React, { FC, useMemo } from 'react';
import { useTheme } from '@mui/material';
import Widget from 'src/components/Widget';
import { ApiServiceImpl } from 'src/api/services';
import VendorsListContent from './Content';
import { TimeSpan } from 'src/viewsTypes';
import { DashboardDataReceipts } from 'src/api/services/types';

const title = 'רשימת ספקים';
type DataType = DashboardDataReceipts['vendors'];

const VendorsList: FC = () => {
  const { spacing } = useTheme();
  const timeSpan: TimeSpan = useMemo(() => ({ timeUnit: 'M', count: 3 }), []);
  const size = useMemo(
    () => ({ width: spacing(80), height: spacing(45) }),
    [spacing],
  );

  return (
    <Widget<DataType>
      title={title}
      size={size}
      filters={{ timeSpan }}
      service={ApiServiceImpl.getVendorsList}
      Content={VendorsListContent}
    />
  );
};

export default VendorsList;
